module.exports = __webpack_public_path__ + "static/img/partner-logo1.bf467846.jpg";